import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { jsPDF } from 'jspdf'
import Loader from '../UI/Loader'
import Modal from '../UI/Modal'
import ServiceSubPageHeader from './ServiceSubPageHeader'
import FilterChip from '../UI/FilterChip'
import OnlyPremiumEmpty from '../UI/OnlyPremiumEmpty'
import PremiumAlert from '../UI/PremiumAlert'

class Bookings extends Component {
	constructor(props) {
		super(props)
		const today = new Date()
		today.setHours(0, 0, 0, 0)
		// Calcule le lundi de la semaine courante
		const dow = today.getDay() // 0=dim,1=lun,...
		const diffToMonday = (dow === 0) ? -6 : 1 - dow
		const monday = new Date(today)
		monday.setDate(today.getDate() + diffToMonday)
		const weekStart = Math.round(monday.getTime() / 1000)

		this.state = {
			view: 'schedule',
			weekStart: weekStart,
			scheduleTab: 'upcoming',
			filterService: 'all',
			filterExpanded: false,

			services: null,
			service_benefits: null,
			service_workers: null,
			webapp_users: null,
			clients: null,
			reservations: [],
			allReservations: [],

			// Modal ajout réservation
			addModal: false,
			addStep: 1,
			addBenefit: null,
			addDay: null,
			addWeekOffset: 0,
			addSlot: null,
			addForm: { client_number: '', user: '', identity: '', age: '', phone: '', email: '', answers: [], participants: [] },
			addClient: null,
			addUsers: [],
			// Panneau détail
			detailReservation: null,
			detailSlot: null,

			// Suppression
			deleteModal: false,
			deleteId: null,

			// Modal édition participant
			editModal: false,
			editReservationId: null,
			editType: null,
			editIdx: null,
			editForm: {},
			editSaving: false,
			editError: null,

			loading: false,
			addError: null,
			addSuccess: null,
			globalError: null,
			globalSuccess: null
		}
		this.props.updateNavbarTitle('Réservations')
		this.pollTimer = null
		// ids des inscriptions déjà affichées — null tant que le premier chargement n'a pas abouti,
		// pour ne jamais notifier le contenu initial de la page
		this.knownReservationIds = null
	}

	componentDidMount() {
		this.loadAll()
		// notif navigateur : demande la permission une fois (best-effort, comme la Messagerie)
		if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'default')
		{
			try { Notification.requestPermission() }
			catch (e) { /* certains navigateurs exigent un geste utilisateur : ignoré */ }
		}
		this.pollTimer = setInterval(this._pollReservations, 15000)
	}

	componentWillUnmount() {
		if (this.pollTimer)
			clearInterval(this.pollTimer)
	}

	componentDidUpdate(prevProps, prevState) {
		const changed = (
			prevState.view !== this.state.view ||
			prevState.weekStart !== this.state.weekStart ||
			prevState.scheduleTab !== this.state.scheduleTab
		)
		if (changed) this._loadReservations()

		// Après rechargement des réservations : mettre à jour addSlot si le modal est ouvert à l'étape 3
		if (
			prevState.reservations !== this.state.reservations &&
			this.state.addModal && this.state.addStep === 3 &&
			this.state.addBenefit && this.state.addDay && this.state.addSlot
		) {
			const freshSlots = this._generateSlots(this.state.addBenefit, this.state.addDay)
			const updated = freshSlots.find(s => s.start === this.state.addSlot.start)
			if (updated) this.setState({ addSlot: updated })
		}

		// Sync données depuis props si mises à jour
		if (prevProps.service_benefits !== this.props.service_benefits && this.props.service_benefits)
			this.setState({ service_benefits: this.props.service_benefits })
		if (prevProps.service_workers !== this.props.service_workers && this.props.service_workers)
			this.setState({ service_workers: this.props.service_workers })
		if (prevProps.clients !== this.props.clients && this.props.clients)
			this.setState({ clients: this.props.clients })
		if (prevProps.webapp_users !== this.props.webapp_users && this.props.webapp_users)
			this.setState({ webapp_users: this.props.webapp_users })
	}

	loadAll = () => {
		Promise.all([
			this.props.fetchServices(),
			this.props.fetchServiceBenefits(),
			this.props.fetchServiceWorkers(),
			this.props.fetchClients(),
			this.props.fetchWebappUsers()
		])
		.then(([services, benefits, workers, clients, users]) => {
			this.setState({
				services: services || [],
				service_benefits: benefits || [],
				service_workers: workers || [],
				clients: clients || [],
				webapp_users: users || []
			}, () => {
				this._loadReservations()
			})
		})
		.catch(err => {
			console.log('loadAll error', err)
			this.setState({ loading: false })
		})
	}

	_getWindowBounds = () => {
		if (this.state.view === 'week') {
			return { start: this.state.weekStart, end: this.state.weekStart + 7 * 86400 }
		} else {
			// schedule view — timestamps in seconds
			const now = Math.round(Date.now() / 1000)
			if (this.state.scheduleTab === 'upcoming') {
				return { start: now, end: now + 180 * 86400 }
			} else {
				return { start: now - 30 * 86400, end: now }
			}
		}
	}

	_loadReservations = () => {
		this.setState({ loading: true, globalError: null })
		const { start, end } = this._getWindowBounds()
		this.props.fetchReservationsByDateRange(start, end, null)
		.then(all => {
			const resas = (all || []).filter(r => !r.cart || r.cart.length === 0)
			// nouveau point de référence : un changement de vue/semaine ne déclenche pas de notification
			this.knownReservationIds = new Set(resas.map(r => String(r._id)))
			const { filterService } = this.state
			const filtered = filterService === 'all' ? resas : resas.filter(r => {
				const sid = (r.service && r.service._id) ? r.service._id : r.service
				return sid === filterService
			})
			this.setState({ allReservations: resas, reservations: filtered, loading: false })
		})
		.catch(err => {
			console.log('fetchReservationsByDateRange error', err)
			this.setState({ loading: false, globalError: 'Erreur lors du chargement des réservations.' })
		})
	}

	// Rafraîchissement silencieux périodique : les nouvelles inscriptions tombent en temps réel,
	// sans spinner ni rechargement de page (même principe que le polling de la Messagerie)
	_pollReservations = () => {
		const { start, end } = this._getWindowBounds()
		this.props.fetchReservationsByDateRange(start, end, null)
		.then(all => {
			const resas = (all || []).filter(r => !r.cart || r.cart.length === 0)
			const known = this.knownReservationIds
			const fresh = (known === null) ? [] : resas.filter(r => !r.cancelled && !known.has(String(r._id)))
			this.knownReservationIds = new Set(resas.map(r => String(r._id)))
			const { filterService } = this.state
			const filtered = filterService === 'all' ? resas : resas.filter(r => {
				const sid = (r.service && r.service._id) ? r.service._id : r.service
				return sid === filterService
			})
			this.setState({ allReservations: resas, reservations: filtered })
			if (fresh.length > 0)
				this._notifyNewReservations(fresh)
		})
		.catch(() => {})
	}

	// Notif navigateur à l'arrivée de nouvelles inscriptions (même principe que la Messagerie)
	_notifyNewReservations = (fresh) => {
		if (typeof window === 'undefined' || !('Notification' in window) || Notification.permission !== 'granted')
			return
		try
		{
			const first = fresh[0]
			const title = (fresh.length > 1)
				? (fresh.length + ' nouvelles inscriptions')
				: 'Nouvelle inscription'
			const body = (fresh.length > 1)
				? 'Plusieurs inscriptions viennent d\'arriver'
				: (this._getParticipantName(first) + ' — ' + this._formatDayFull(first.start) + ' à ' + this._formatTime(first.start))
			const notif = new Notification(title, { body: body, tag: 'pocketcamp-inscriptions' })
			notif.onclick = () => {
				try { window.focus() } catch (e) {}
				notif.close()
			}
		}
		catch (e) { /* échec silencieux */ }
	}

	// ─── Helpers ────────────────────────────────────────────────────────────────

	_getWeekDays = () => {
		const days = []
		for (let i = 0; i < 7; i++)
			days.push(this.state.weekStart + i * 86400)
		return days
	}

	_filterByDay = (dayTs) => {
		const start = dayTs
		const end = dayTs + 86400
		return this.state.reservations.filter(r => r.start >= start && r.start < end)
	}

	_groupByService = (reservations) => {
		const map = {}
		const order = []
		for (let i = 0; i < reservations.length; i++) {
			const sid = reservations[i].service
			if (!map[sid]) { map[sid] = []; order.push(sid) }
			map[sid].push(reservations[i])
		}
		return order.map(sid => ({ serviceId: sid, reservations: map[sid] }))
	}

	_groupBySlot = (reservations) => {
		const map = {}
		const order = []
		for (let i = 0; i < reservations.length; i++) {
			const r = reservations[i]
			const sid = (r.service && r.service._id) ? r.service._id : r.service
			const bid = (r.service_benefit && r.service_benefit._id) ? r.service_benefit._id : r.service_benefit
			const key = sid + '_' + r.start
			if (!map[key]) {
				map[key] = { benefitId: bid, serviceId: sid, slotStart: r.start, slotEnd: r.end, resas: [] }
				order.push(key)
			}
			map[key].resas.push(r)
		}
		return order.map(k => map[k]).sort((a, b) => a.slotStart - b.slotStart)
	}

	_getServiceTitle = (id) => {
		const services = this.state.services || []
		for (let i = 0; i < services.length; i++) {
			if (services[i]._id === id) {
				const translations = services[i].translations || []
				for (let j = 0; j < translations.length; j++) {
					if (translations[j].lang === this.props.lang_default)
						return translations[j].title
				}
				if (translations.length > 0) return translations[0].title
				return services[i].name || id
			}
		}
		return id
	}

	_getBenefitTitle = (id) => {
		const benefits = this.state.service_benefits || []
		for (let i = 0; i < benefits.length; i++) {
			if (benefits[i]._id === id) {
				const translations = benefits[i].translations || []
				for (let j = 0; j < translations.length; j++) {
					if (translations[j].lang === this.props.lang_default)
						return translations[j].subtitle || translations[j].title || ''
				}
				return ''
			}
		}
		return ''
	}

	_getWorkerName = (id) => {
		const workers = this.state.service_workers || []
		for (let i = 0; i < workers.length; i++) {
			if (workers[i]._id === id)
				return workers[i].firstname + ' ' + workers[i].lastname
		}
		return ''
	}

	_getParticipantName = (r) => {
		if (r.user && typeof r.user === 'object')
			return r.user.firstname + ' ' + r.user.lastname
		if (r.identity && r.identity.length > 0)
			return r.identity
		return '—'
	}

	_formatTime = (ts) => {
		const d = new Date(ts * 1000)
		let h = d.getHours(); if (h < 10) h = '0' + h
		let m = d.getMinutes(); if (m < 10) m = '0' + m
		return h + ':' + m
	}

	_formatDayFull = (ts) => {
		const days = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.']
		const months = ['jan.', 'fév.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sep.', 'oct.', 'nov.', 'déc.']
		const d = new Date(ts * 1000)
		return days[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear()
	}

	_formatDayShort = (ts) => {
		const days = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.']
		const months = ['jan', 'fév', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sep', 'oct', 'nov', 'déc']
		const d = new Date(ts * 1000)
		return { day: days[d.getDay()], num: d.getDate(), month: months[d.getMonth()] }
	}

	_formatWeekRange = () => {
		const start = new Date(this.state.weekStart * 1000)
		const end = new Date((this.state.weekStart + 6 * 86400) * 1000)
		const months = ['jan.', 'fév.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sep.', 'oct.', 'nov.', 'déc.']
		let s = start.getDate()
		if (start.getMonth() !== end.getMonth())
			s += ' ' + months[start.getMonth()]
		return s + ' – ' + end.getDate() + ' ' + months[end.getMonth()] + ' ' + end.getFullYear()
	}

	_formatWeekMonthLabel = () => {
		const start = new Date(this.state.weekStart * 1000)
		const end = new Date((this.state.weekStart + 6 * 86400) * 1000)
		const monthsFull = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre']
		const monthsShort = ['jan.', 'fév.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sep.', 'oct.', 'nov.', 'déc.']
		if (start.getMonth() === end.getMonth()) {
			return monthsFull[start.getMonth()] + ' ' + start.getFullYear()
		}
		return monthsFull[start.getMonth()] + ' – ' + monthsShort[end.getMonth()] + ' ' + end.getFullYear()
	}

	_isToday = (ts) => {
		const today = new Date(); today.setHours(0,0,0,0)
		const d = new Date(ts * 1000); d.setHours(0,0,0,0)
		return today.getTime() === d.getTime()
	}

	// ts in seconds → midnight in seconds
	_getMidnight = (ts) => {
		const d = new Date(ts * 1000)
		d.setHours(0, 0, 0, 0)
		return Math.round(d.getTime() / 1000)
	}

	_getBenefit = (id) => {
		const benefits = this.state.service_benefits || []
		for (let i = 0; i < benefits.length; i++)
			if (benefits[i]._id === id) return benefits[i]
		return null
	}

	// Formats a midnight-seconds timestamp as a day label for schedule headers
	_formatDay = (ts) => {
		const DAYS = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi']
		const MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
		const d = new Date(ts * 1000)
		const today = new Date(); today.setHours(0, 0, 0, 0)
		const diff = d.getTime() - today.getTime()
		if (diff === 0) return "Aujourd'hui"
		if (diff === 86400000) return 'Demain'
		return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]
	}

	// ─── Navigation ─────────────────────────────────────────────────────────────

	prevWeek = () => this.setState(s => ({ weekStart: s.weekStart - 7 * 86400 }))
	nextWeek = () => this.setState(s => ({ weekStart: s.weekStart + 7 * 86400 }))

	goToToday = () => {
		const today = new Date()
		today.setHours(0, 0, 0, 0)
		const dow = today.getDay()
		const diffToMonday = (dow === 0) ? -6 : 1 - dow
		const monday = new Date(today)
		monday.setDate(today.getDate() + diffToMonday)
		this.setState({ view: 'week', weekStart: Math.round(monday.getTime() / 1000) })
	}

	// ─── Filtres ─────────────────────────────────────────────────────────────────

	_applyServiceFilter = (serviceId) => {
		const all = this.state.allReservations
		const filtered = serviceId === 'all' ? all : all.filter(r => {
			const sid = (r.service && r.service._id) ? r.service._id : r.service
			return sid === serviceId
		})
		this.setState({ filterService: serviceId, reservations: filtered })
	}

	handleFilterService = (e) => {
		this.setState({ filterService: e.target.value })
	}

	// ─── Export CSV ──────────────────────────────────────────────────────────────

	_downloadCsv = () => {
		const { reservations, service_benefits, webapp_users, clients } = this.state
		const lang = this.props.lang_default || 'fr'
		const esc = (v) => '"' + String(v == null ? '' : v).replace(/"/g, '""') + '"'

		const sorted = [...reservations].filter(r => !r.cancelled).sort((a, b) => a.start - b.start)

		// Collect all unique questions across reservations (keyed by benefitId_questionIndex)
		const questionCols = [] // [{ key, label }]
		const questionKeySet = new Set()
		for (const r of sorted) {
			const bId = (r.service_benefit && r.service_benefit._id) ? r.service_benefit._id : r.service_benefit
			const benefit = (service_benefits || []).find(b => String(b._id) === String(bId))
			if (!benefit || !benefit.questions) continue
			benefit.questions.forEach((q, idx) => {
				const key = String(bId) + '_' + idx
				if (questionKeySet.has(key)) return
				questionKeySet.add(key)
				const t = (q.translations || []).find(t => t.lang === lang) || (q.translations || [])[0]
				questionCols.push({ key, bId: String(bId), idx, label: t ? t.title : ('Q' + (idx + 1)) })
			})
		}

		const headers = ['Service', 'Date', 'Heure', 'Nb. Participants', 'Prénom', 'Nom', 'E-mail', 'Téléphone', 'Accompagnants', ...questionCols.map(q => q.label)]
		const rows = [headers.map(esc).join(';')]

		for (const r of sorted) {
			const bId = (r.service_benefit && r.service_benefit._id) ? r.service_benefit._id : r.service_benefit
			const benefit = (service_benefits || []).find(b => String(b._id) === String(bId))

			// Service name
			let serviceName = ''
			if (benefit && benefit.translations) {
				const t = benefit.translations.find(t => t.lang === lang) || benefit.translations[0]
				if (t) serviceName = t.subtitle || ''
			}

			// Date & heure
			const d = new Date(r.start * 1000)
			const date = String(d.getDate()).padStart(2, '0') + '/' + String(d.getMonth() + 1).padStart(2, '0') + '/' + d.getFullYear()
			const heure = String(d.getHours()).padStart(2, '0') + 'h' + String(d.getMinutes()).padStart(2, '0')

			// Participant principal
			let firstname = '', lastname = '', email = '', phone = r.phone || ''
			if (r.user) {
				const u = (webapp_users || []).find(u => String(u._id) === String(r.user))
				if (u) { firstname = u.firstname || ''; lastname = u.lastname || ''; email = u.email || ''; phone = phone || u.phone || '' }
			}
			if (!firstname && r.identity) firstname = r.identity
			if (!firstname && r.client_number) {
				const c = (clients || []).find(c => c.client_number === r.client_number)
				if (c) { firstname = c.firstname || ''; lastname = c.lastname || '' }
			}

			const accompagnants = (r.participants || []).map(p => (p.identity || ((p.firstname || '') + ' ' + (p.lastname || '')).trim()) || '').join(', ')
			const nb = (r.self === true ? 1 : 0) + (r.participants ? r.participants.length : 0)

			// Answers — one cell per question column, empty if not applicable
			const answers = questionCols.map(q => {
				if (q.bId !== String(bId)) return ''
				return (r.answers && r.answers[q.idx] != null) ? r.answers[q.idx] : ''
			})

			rows.push([serviceName, date, heure, nb, firstname, lastname, email, phone, accompagnants, ...answers].map(esc).join(';'))
		}

		const blob = new Blob(['\uFEFF' + rows.join('\n')], { type: 'text/csv;charset=utf-8;' })
		const url = URL.createObjectURL(blob)
		const a = document.createElement('a')
		a.href = url
		const { start } = this._getWindowBounds()
		const ds = new Date(start * 1000)
		a.download = 'reservations_' + ds.getFullYear() + '-' + String(ds.getMonth() + 1).padStart(2, '0') + '-' + String(ds.getDate()).padStart(2, '0') + '.csv'
		a.click()
		URL.revokeObjectURL(url)
	}

	// ─── Panneau détail ──────────────────────────────────────────────────────────

	openDetail = (r) => this.setState({ detailReservation: r })
	closeDetail = () => this.setState({ detailReservation: null })

	openSlotDetail = (slot) => this.setState({ detailSlot: slot })
	closeSlotDetail = () => this.setState({ detailSlot: null })

	// ─── Impression ticket ───────────────────────────────────────────────────────

	_printTicket = (r) => {
		const lang = this.props.lang_default || 'fr'
		const benefitTitle = this._getBenefitTitle(r.service_benefit)
		const serviceName = this._getServiceTitle(r.service)
		const workerName = this._getWorkerName(r.service_worker)
		const name = this._getParticipantName(r)
		const isCancelled = !!r.cancelled

		const benefit = (() => {
			const bid = (r.service_benefit && r.service_benefit._id) ? r.service_benefit._id : r.service_benefit
			const benefits = this.state.service_benefits || []
			for (let i = 0; i < benefits.length; i++)
				if (benefits[i]._id === bid) return benefits[i]
			return null
		})()

		const W = 80
		const MIN_H = 105
		const margin = 6
		const usable = W - margin * 2
		const lineH = 5.5
		const smallH = 4.5

		const renderContent = (d) => {
			let y = margin

			const addText = (text, opts = {}) => {
				const { size = 9, bold = false, align = 'left', color = [0, 0, 0] } = opts
				d.setFontSize(size)
				d.setFont('helvetica', bold ? 'bold' : 'normal')
				d.setTextColor(...color)
				const x = align === 'center' ? W / 2 : align === 'right' ? W - margin : margin
				d.text(String(text), x, y, { align })
				y += (size >= 10 ? lineH : smallH)
			}
			const addDivider = () => {
				y += 1
				d.setDrawColor(180, 180, 180)
				d.setLineWidth(0.2)
				d.setLineDash([1.5, 1.5])
				d.line(margin, y, W - margin, y)
				d.setLineDash([])
				y += 4
			}
			const addLabel = (text) => {
				d.setFontSize(7)
				d.setFont('helvetica', 'bold')
				d.setTextColor(120, 120, 120)
				d.text(text.toUpperCase(), margin, y)
				y += 4.5
			}
			const addRow = (left, right) => {
				d.setFontSize(8.5)
				d.setFont('helvetica', 'normal')
				d.setTextColor(0, 0, 0)
				const rightW = d.getTextWidth(String(right))
				const leftLines = d.splitTextToSize(String(left), usable - rightW - 2)
				d.text(leftLines, margin, y)
				d.text(String(right), W - margin, y, { align: 'right' })
				y += leftLines.length * smallH
			}

			addText(serviceName, { size: 11, bold: true, align: 'center' })
			if (benefitTitle)
				addText(benefitTitle, { size: 8.5, align: 'center', color: [100, 100, 100] })
			if (isCancelled)
			{
				y += 1
				d.setFontSize(9)
				d.setFont('helvetica', 'bold')
				d.setTextColor(120, 120, 120)
				d.setDrawColor(160, 160, 160)
				d.setLineWidth(0.3)
				d.rect(margin, y, usable, 6)
				d.text('RÉSERVATION ANNULÉE', W / 2, y + 4, { align: 'center' })
				y += 8
			}
			addDivider()
			addLabel('Créneau')
			addText(this._formatDayFull(r.start), { size: 8.5 })
			addText(`${this._formatTime(r.start)} - ${this._formatTime(r.end)}`, { size: 9, bold: true })
			if (workerName)
				addText(`Par ${workerName}`, { size: 8.5, color: [80, 80, 80] })
			y += 1
			addDivider()
			addLabel('Participant')
			addText(name, { size: 9, bold: true })
			if (r.client_number)
				addText(`Client #${r.client_number}`, { size: 8.5, color: [80, 80, 80] })
			if (r.age > 0)
				addText(`${r.age} ans`, { size: 8.5, color: [80, 80, 80] })
			if (r.phone)
				addText(`Tél : ${r.phone}`, { size: 8.5, color: [80, 80, 80] })
			if (r.participants && r.participants.length > 0)
			{
				addDivider()
				addLabel('Accompagnants')
				for (const p of r.participants)
				{
					const pName = p.identity || ((p.firstname || '') + ' ' + (p.lastname || '')).trim() || '—'
					const details = [p.age > 0 ? `${p.age} ans` : null, p.phone ? p.phone : null].filter(Boolean).join(' · ')
					addText(pName, { size: 8.5, bold: true })
					if (details)
						addText(details, { size: 8, color: [80, 80, 80] })
				}
			}
			if (benefit && benefit.questions && benefit.questions.length > 0 && r.answers && r.answers.length > 0)
			{
				const answerPairs = benefit.questions.map((q, idx) => {
					if (!r.answers[idx]) return null
					const qTitle = q.translations ? ((q.translations.find(t => t.lang === lang) || q.translations[0] || {}).title || '') : ''
					return { q: qTitle, a: r.answers[idx] }
				}).filter(Boolean)
				if (answerPairs.length > 0)
				{
					addDivider()
					addLabel('Réponses')
					for (const { q, a } of answerPairs)
						addRow(q, a)
				}
			}

			return y
		}

		const measureDoc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: [W, 500] })
		const contentY = renderContent(measureDoc)
		const H = Math.max(MIN_H, contentY + margin)
		const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: [W, H] })
		renderContent(doc)

		window.open(doc.output('bloburl'), '_blank')
	}

	// ─── Suppression ─────────────────────────────────────────────────────────────

	askDelete = (id, e) => {
		e.stopPropagation()
		this.setState({ deleteModal: true, deleteId: id, detailReservation: null, detailSlot: null })
	}

	answerModal = (answer) => {
		if (answer === 'yes') {
			this.props.cancelServiceReservation(this.state.deleteId)
			.then(ret => {
				this.setState({ deleteModal: false, deleteId: null })
				if (ret === true) {
					this.setState({ globalSuccess: 'Réservation annulée.' })
					this._loadReservations()
				} else {
					this.setState({ globalError: 'Une erreur s\'est produite lors de l\'annulation.' })
				}
			})
			.catch(() => {
				this.setState({ deleteModal: false, deleteId: null, globalError: 'Une erreur s\'est produite.' })
			})
		} else {
			this.setState({ deleteModal: false, deleteId: null })
		}
	}

	// ─── Modal ajout ─────────────────────────────────────────────────────────────

	openAddModal = () => {
		const d = new Date(); d.setHours(0, 0, 0, 0)
		const defaultDay = Math.round(d.getTime() / 1000)
		this.setState({
			addModal: true,
			addStep: 1,
			addBenefit: null,
			addDay: defaultDay,
			addWeekOffset: 0,
			addSlot: null,
			addForm: { client_number: '', user: '', identity: '', age: '', phone: '', email: '', answers: [], participants: [] },
			addClient: null,
			addUsers: [],
			addError: null,
			addSuccess: null
		})
	}
	closeAddModal = () => this.setState({ addModal: false })

	selectAddBenefit = (benefit) => {
		this.setState({ addBenefit: benefit, addStep: 2, addSlot: null, addError: null })
	}

	selectAddDay = (dayTs) => {
		this.setState({ addDay: dayTs, addSlot: null })
	}

	selectAddSlot = (slot) => {
		const benefit = this.state.addBenefit
		this.setState({
			addSlot: slot,
			addStep: 3,
			addError: null,
			addSuccess: null,
			addForm: { client_number: '', user: '', identity: '', age: '', phone: '', answers: benefit && benefit.questions ? benefit.questions.map(() => '') : [], participants: [] },
			addClient: null,
			addUsers: []
		})
	}

	_getAddWeekDays = () => {
		const { addWeekOffset } = this.state
		const today = new Date(); today.setHours(0, 0, 0, 0)
		const dow = today.getDay()
		const diffToMonday = (dow === 0) ? -6 : 1 - dow
		const monday = new Date(today)
		monday.setDate(today.getDate() + diffToMonday + addWeekOffset * 7)
		const days = []
		for (let i = 0; i < 7; i++) {
			const d = new Date(monday); d.setDate(monday.getDate() + i)
			days.push(Math.round(d.getTime() / 1000))
		}
		return days
	}

	_generateSlots = (benefit, dayTs) => {
		if (!benefit || !dayTs) return []
		const date = new Date(dayTs * 1000)
		const year = date.getFullYear()
		const weekday = date.getDay()
		const DAY_KEYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

		let inSeason = false
		for (const od of (benefit.open_dates || [])) {
			const start = Math.round(new Date(year, od.start_month - 1, od.start_day).getTime() / 1000)
			const end = Math.round(new Date(year, od.end_month - 1, od.end_day).getTime() / 1000)
			if (dayTs >= start && dayTs <= end) { inSeason = true; break }
		}
		if (!inSeason) return []

		const applicable = (benefit.open_hours || []).filter(oh => oh[DAY_KEYS[weekday]])
		if (applicable.length === 0) return []

		const ranges = applicable.map(oh => ({ start: oh.start_hour * 60 + oh.start_minute, end: oh.end_hour * 60 + oh.end_minute })).sort((a, b) => a.start - b.start)
		const merged = [{ ...ranges[0] }]
		for (let i = 1; i < ranges.length; i++) {
			const last = merged[merged.length - 1]
			if (ranges[i].start <= last.end) { last.end = Math.max(last.end, ranges[i].end) }
			else { merged.push({ ...ranges[i] }) }
		}

		const duration = benefit.duration_hour * 60 + benefit.duration_minute
		const interval = benefit.interval_hour * 60 + benefit.interval_minute
		const reservations = this.state.reservations || []
		const slots = []

		for (const range of merged) {
			let startSlot = range.start
			let endSlot = startSlot + duration
			while (endSlot + interval <= range.end) {
				const slotStartTs = startSlot * 60 + dayTs
				const slotEndTs = endSlot * 60 + dayTs
				let booked = 0
				for (const r of reservations) {
					if (r.cancelled) continue
					const rBid = (r.service_benefit && r.service_benefit._id) ? r.service_benefit._id : r.service_benefit
					if (rBid !== benefit._id) continue
					if ((r.start <= slotStartTs && r.end > slotStartTs) || (r.start > slotStartTs && r.start < slotEndTs)) {
						booked += 1 + (r.participants ? r.participants.length : 0)
					}
				}
				slots.push({ start: startSlot, end: endSlot, booked })
				startSlot = endSlot + interval
				endSlot = startSlot + duration
			}
		}
		return slots
	}

	_findNextAvailableDay = (benefit, fromDayTs) => {
		for (let i = 1; i <= 365; i++) {
			const d = new Date(fromDayTs * 1000); d.setDate(d.getDate() + i); d.setHours(0, 0, 0, 0)
			const t = Math.round(d.getTime() / 1000)
			if (this._generateSlots(benefit, t).length > 0) return t
		}
		return null
	}

	goToNextAvailableDay = (dayTs) => {
		const today = new Date(); today.setHours(0, 0, 0, 0)
		const dow = today.getDay()
		const diffToMonday = (dow === 0) ? -6 : 1 - dow
		const thisMonday = new Date(today); thisMonday.setDate(today.getDate() + diffToMonday)
		const thisMondayTs = Math.round(thisMonday.getTime() / 1000)
		const diffDays = Math.round((dayTs - thisMondayTs) / 86400)
		const weekOffset = Math.floor(diffDays / 7)
		this.setState({ addDay: dayTs, addWeekOffset: weekOffset, addSlot: null })
	}

	handleAddField = (field, e) => {
		this.setState({ addForm: { ...this.state.addForm, [field]: e.target.value } })
	}

	handleUserSelect = (e) => {
		const userId = e.target.value
		const addForm = { ...this.state.addForm, user: userId }
		if (userId) {
			const user = (this.state.webapp_users || []).find(u => u._id === userId)
			if (user) {
				const today = new Date()
				const civ = user.civility === 'femme' ? 'Mme. ' : user.civility === 'homme' ? 'Mr. ' : ''
				addForm.identity = civ + user.firstname + ' ' + user.lastname
				if (user.birthday) {
					const y = Number(user.birthday.substr(6, 4)), m = Number(user.birthday.substr(3, 2)) - 1, d = Number(user.birthday.substr(0, 2))
					let a = today.getFullYear() - y
					if (m > today.getMonth() || (m === today.getMonth() && d > today.getDate())) a--
					addForm.age = String(a)
				}
				if (user.phone) addForm.phone = user.phone
			}
		}
		this.setState({ addForm })
	}

	handleAddAnswer = (idx, e) => {
		const answers = [...this.state.addForm.answers]
		answers[idx] = e.target.value
		this.setState({ addForm: { ...this.state.addForm, answers } })
	}

	addParticipant = () => {
		const { addForm } = this.state
		const participants = [...addForm.participants, { identity: '', age: '', phone: '' }]
		this.setState({ addForm: { ...addForm, participants } })
	}

	removeParticipant = (idx) => {
		const { addForm } = this.state
		const participants = addForm.participants.filter((_, i) => i !== idx)
		this.setState({ addForm: { ...addForm, participants } })
	}

	handleParticipantField = (idx, field, e) => {
		const { addForm } = this.state
		const participants = addForm.participants.map((p, i) => i === idx ? { ...p, [field]: e.target.value } : p)
		this.setState({ addForm: { ...addForm, participants } })
	}

	lookupClient = (numOverride) => {
		const num = numOverride !== undefined ? numOverride : this.state.addForm.client_number
		if (!num) { this.setState({ addClient: null, addUsers: [] }); return }
		const clients = this.state.clients || []
		let client = null
		for (let i = 0; i < clients.length; i++) {
			if (String(clients[i].client_number) === String(num)) { client = clients[i]; break }
		}
		const users = []
		if (client) {
			const webapp_users = this.state.webapp_users || []
			for (let i = 0; i < webapp_users.length; i++)
				if (String(webapp_users[i].client_number) === String(num))
					users.push(webapp_users[i])
		}
		const addForm = { ...this.state.addForm, client_number: num }
		const today = new Date()
		if (client) {
			if (!addForm.identity) {
				const civ = client.civility === 'femme' ? 'Mme. ' : client.civility === 'homme' ? 'Mr. ' : ''
				addForm.identity = civ + client.firstname + ' ' + client.lastname
			}
			if (!addForm.age && client.birthday) {
				const y = Number(client.birthday.substr(6, 4)), m = Number(client.birthday.substr(3, 2)) - 1, d = Number(client.birthday.substr(0, 2))
				let a = today.getFullYear() - y
				if (m > today.getMonth() || (m === today.getMonth() && d > today.getDate())) a--
				addForm.age = String(a)
			}
			if (!addForm.phone) addForm.phone = client.phone1 || client.phone2 || client.phone3 || ''
			if (!addForm.email) addForm.email = client.email1 || client.email2 || ''
		}
		this.setState({ addClient: client, addUsers: users, addForm })
	}

	submitAdd = (e, addAnother = false) => {
		if (e) e.preventDefault()
		const { addForm, addBenefit, addDay, addSlot } = this.state
		if (!addBenefit || !addDay || !addSlot) return

		if (!addForm.identity || !addForm.identity.trim()) { this.setState({ addError: 'Le nom / prénom est obligatoire.' }); return }
		if (addBenefit.age && !addForm.age) { this.setState({ addError: 'L\'âge est obligatoire.' }); return }
		if (addBenefit.age) {
			for (let i = 0; i < addForm.participants.length; i++) {
				if (!addForm.participants[i].age) {
					this.setState({ addError: 'L\'âge est obligatoire pour l\'accompagnant ' + (i + 1) + '.' }); return
				}
			}
		}
		if (addBenefit.simultaneous > 0) {
			const remaining = addBenefit.simultaneous - addSlot.booked
			if (1 + addForm.participants.length > remaining) {
				this.setState({ addError: 'Le nombre de participants dépasse la capacité disponible (' + remaining + ' place(s) restante(s)).' }); return
			}
		}
		if (addBenefit.questions) {
			for (let i = 0; i < addBenefit.questions.length; i++) {
				if (addBenefit.questions[i].mandatory && !addForm.answers[i]) {
					this.setState({ addError: 'Veuillez répondre à toutes les questions obligatoires.' }); return
				}
			}
		}

		const start = addDay + addSlot.start * 60
		const end = addDay + addSlot.end * 60
		const reservation = {
			service: addBenefit.service,
			service_worker: null,
			service_benefit: addBenefit._id,
			start, end,
			answers: addForm.answers,
			user: addForm.user || null,
			client_number: addForm.client_number,
			identity: addForm.identity,
			age: addForm.age,
			phone: addForm.phone,
			email: addForm.email,
			self: true,
			from: 'dashboard',
			participants: addForm.participants.filter(p => p.identity || p.phone || p.age)
		}

		this.setState({ addError: null })
		this.props.insertServiceReservation(reservation)
		.then(ret => {
			if (!ret) {
				this.setState({ addError: 'Une erreur s\'est produite lors de la création.' })
			} else if (addAnother) {
				this.setState({
					addSuccess: 'Participant ajouté avec succès.',
					addForm: { client_number: '', user: '', identity: '', age: '', phone: '', email: '', answers: addBenefit.questions ? addBenefit.questions.map(() => '') : [], participants: [] },
					addClient: null, addUsers: [], addError: null
				})
				this._loadReservations()
			} else {
				this.setState({ addModal: false, globalSuccess: 'Réservation ajoutée avec succès.' })
				this._loadReservations()
			}
		})
		.catch(() => { this.setState({ addError: 'Une erreur s\'est produite.' }) })
	}

	// ─── Édition participant ─────────────────────────────────────────────────────

	openEditModal = (r, type, idx = null) => {
		let form = {}
		if (type === 'holder') {
			form = { identity: r.identity || '', age: r.age || '', phone: r.phone || '', client_number: r.client_number || '' }
		} else {
			const p = r.participants[idx]
			form = { identity: p.identity || ((p.firstname || '') + ' ' + (p.lastname || '')).trim() || '', age: p.age || '', phone: p.phone || '' }
		}
		this.setState({ editModal: true, editReservationId: r._id, editType: type, editIdx: idx, editForm: form, editSaving: false, editError: null })
	}

	closeEditModal = () => this.setState({ editModal: false, editReservationId: null, editType: null, editIdx: null, editForm: {}, editError: null })

	deleteCompanion = (r, idx) => {
		if (!window.confirm('Supprimer cet accompagnant ?')) return
		const participants = (r.participants || []).filter((_, i) => i !== idx)
		this.props.updateServiceReservation(r._id, { participants })
		.then(ret => {
			if (ret === true) this._loadReservations()
			else this.setState({ globalError: 'Erreur lors de la suppression.' })
		})
		.catch(() => this.setState({ globalError: 'Erreur lors de la suppression.' }))
	}

	saveEdit = () => {
		const { editReservationId, editType, editIdx, editForm, editSaving } = this.state
		if (editSaving) return
		this.setState({ editSaving: true, editError: null })

		let fields = {}
		if (editType === 'holder') {
			fields = { identity: editForm.identity, age: editForm.age, phone: editForm.phone, client_number: editForm.client_number }
		} else {
			// rebuild participants array
			const r = this.state.reservations.find(x => x._id === editReservationId)
			|| this.state.allReservations.find(x => x._id === editReservationId)
			if (!r) { this.setState({ editSaving: false, editError: 'Réservation introuvable.' }); return }
			const participants = (r.participants || []).map((p, i) => {
				if (i !== editIdx) return p
				return { ...p, identity: editForm.identity, age: editForm.age, phone: editForm.phone }
			})
			fields = { participants }
		}

		this.props.updateServiceReservation(editReservationId, fields)
		.then(ret => {
			if (ret === true) {
				this.closeEditModal()
				this._loadReservations()
			} else {
				this.setState({ editSaving: false, editError: "Une erreur s'est produite." })
			}
		})
		.catch(() => this.setState({ editSaving: false, editError: "Une erreur s'est produite." }))
	}

	// ─── Rendu helpers ───────────────────────────────────────────────────────────

	_renderSourceBadge = (from) => {
		if (from === 'dashboard')
			return <span className="text-base px-2 py-0.5 rounded-full bg-green-100 text-green-700 shrink-0">dashboard</span>
		return <span className="text-base px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 shrink-0">app</span>
	}

	_renderReservationRow = (r, showDelete = true) => {
		const name = this._getParticipantName(r)
		const clientNum = r.client_number ? ' #' + r.client_number : ''
		const isCancelled = !!r.cancelled
		return (
			<div
				key={r._id}
				className={`flex items-center gap-3 px-4 py-3 border-b border-gray-100 cursor-pointer transition-colors ${isCancelled ? 'opacity-50 bg-gray-50' : 'hover:bg-gray-50'}`}
				onClick={() => this.openDetail(r)}
			>
				<span className="text-base font-semibold text-gray-400 w-14 shrink-0">{this._formatTime(r.start)}</span>
				<div className="flex-1 min-w-0 flex items-center gap-2">
					<span className={`text-base font-medium text-gray-900 truncate ${isCancelled ? 'line-through' : ''}`}>{name}</span>
					{clientNum && <span className="text-base text-gray-400">{clientNum}</span>}
					{isCancelled && <span className="text-xs bg-red-100 text-red-500 font-semibold px-1.5 py-0.5 rounded shrink-0">Annulé {r.cancelled_by === 'client' ? '(client)' : r.cancelled_by === 'staff' ? '(staff)' : ''}</span>}
				</div>
				{this._renderSourceBadge(r.from)}
				{showDelete && !isCancelled && (
					<button
						className="text-gray-300 hover:text-orange-500 transition-colors shrink-0 text-base leading-none"
						onClick={(e) => this.askDelete(r._id, e)}
						title="Annuler"
					>✕</button>
				)}
			</div>
		)
	}

	// ─── Rendu vue Semaine ───────────────────────────────────────────────────────

	_renderWeekView = () => {
		const days = this._getWeekDays()
		const DAYS_FR = ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.']
		const SERVICE_COLORS = ['#6366f1', '#f97316', '#10b981', '#f59e0b', '#3b82f6', '#ec4899', '#8b5cf6', '#14b8a6']

		// Construire la colorMap à partir de tous les créneaux de la semaine
		const colorMap = {}
		days.forEach(dayTs => {
			this._groupBySlot(this._filterByDay(dayTs)).forEach(({ serviceId }) => {
				if (!(serviceId in colorMap))
					colorMap[serviceId] = SERVICE_COLORS[Object.keys(colorMap).length % SERVICE_COLORS.length]
			})
		})

		return (
			<div className="mx-6 border border-gray-200 rounded-2xl overflow-hidden">
				<div className="overflow-x-auto">
				<div className="grid grid-cols-7 divide-x divide-gray-200 min-w-[700px] min-h-[320px]">
					{days.map(dayTs => {
						const d = new Date(dayTs * 1000)
						const dayLabel = DAYS_FR[d.getDay()]
						const dayNum = d.getDate()
						const isToday = this._isToday(dayTs)
						const dayResas = this._filterByDay(dayTs)
						const slots = this._groupBySlot(dayResas)

						return (
							<div key={dayTs} className={isToday ? 'bg-indigo-50' : 'bg-white'}>
								{/* En-tête jour */}
								<div
									className="sticky top-0 z-10 border-b border-gray-200 px-2 py-2 text-center"
									style={{ backgroundColor: isToday ? '#EEF2FF' : 'white' }}
								>
									<p className="text-base text-gray-400 uppercase tracking-wide">{dayLabel}</p>
									<p className={`text-base font-bold ${isToday ? 'text-indigo-600' : 'text-gray-800'}`}>{dayNum}</p>
								</div>

								{/* Créneaux */}
								<div className="px-2 py-2 space-y-2">
									{slots.length === 0 ? (
										<p className="text-base text-gray-300 text-center py-2">—</p>
									) : (
										slots.map(slot => {
											const { benefitId, serviceId, slotStart, slotEnd, resas } = slot
											const serviceTitle = this._getServiceTitle(serviceId)
											const benefit = this._getBenefit(benefitId)
											const simultaneous = benefit ? benefit.simultaneous : 0
											const activeResas = resas.filter(r => !r.cancelled)
											const resaCount = activeResas.length
											const count = activeResas.reduce((acc, r) => acc + 1 + (r.participants ? r.participants.length : 0), 0)
											const cancelledCount = resas.filter(r => r.cancelled).length
											const hasCapacity = simultaneous && simultaneous > 0
											const pct = hasCapacity ? Math.min(100, Math.round(count / simultaneous * 100)) : 0
											const color = colorMap[serviceId] || '#6366f1'

											return (
												<div
													key={serviceId + '_' + slotStart}
													className="rounded-lg bg-white border border-gray-200 overflow-hidden cursor-pointer hover:border-gray-300 hover:shadow-sm transition-all relative"
													onClick={() => this.openSlotDetail(slot)}
												>
													{/* Trait couleur gauche */}
													<div
														className="absolute left-0 top-0 bottom-0 w-1"
														style={{ backgroundColor: color }}
													/>
													<div className="pl-3 pr-2 py-4">
														<p className="text-sm font-black text-gray-800 truncate leading-tight">{serviceTitle}</p>
														<p className="text-xs text-gray-400 leading-tight mt-2">
															<span>•</span> {this._formatTime(slotStart)} – {this._formatTime(slotEnd)}
														</p>
														<div className="flex items-center gap-3 mt-3">
															{/* Participants chip */}
															<span className="flex items-center gap-1 text-xs font-bold px-2 py-0.5 rounded-full" style={{ color, backgroundColor: color + '20' }}>
																<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
																{hasCapacity ? `${count} / ${simultaneous}` : count}
															</span>
															{/* Ticket count */}
															<span className="flex items-center gap-1 text-xs font-bold text-gray-400">
																<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M13 5v2"/><path d="M13 17v2"/><path d="M13 11v2"/></svg>
																{resaCount}
															</span>
															{cancelledCount > 0 && <span className="text-xs text-gray-300">({cancelledCount} ✕)</span>}
														</div>
														{hasCapacity && (
															<div className="mt-2.5 h-1 rounded-full bg-gray-100 overflow-hidden">
																<div
																	className="h-full rounded-full"
																	style={{
																		width: pct + '%',
																		backgroundColor: pct >= 80 ? '#ef4444' : color
																	}}
																/>
															</div>
														)}
													</div>
												</div>
											)
										})
									)}
								</div>
							</div>
						)
					})}
				</div>
				</div>
			</div>
		)
	}

	// ─── Vue Planning ────────────────────────────────────────────────────────────

	_buildSchedule = () => {
		const { reservations } = this.state
		const sorted = [...reservations].sort((a, b) => a.start - b.start)
		const byDay = {}

		sorted.forEach(r => {
			const dayTs = this._getMidnight(r.start)
			if (!byDay[dayTs]) byDay[dayTs] = {}
			const bid = (r.service_benefit && r.service_benefit._id) ? r.service_benefit._id : r.service_benefit
			const sid = (r.service && r.service._id) ? r.service._id : r.service
			if (!byDay[dayTs][sid]) byDay[dayTs][sid] = {}
			const key = bid + '_' + r.start
			if (!byDay[dayTs][sid][key]) {
				byDay[dayTs][sid][key] = {
					benefitId: bid,
					serviceId: sid,
					slotStart: r.start,
					slotEnd: r.end,
					resas: []
				}
			}
			byDay[dayTs][sid][key].resas.push(r)
		})

		return Object.keys(byDay)
			.sort((a, b) => Number(a) - Number(b))
			.map(dayTs => ({
				dayTs: Number(dayTs),
				services: Object.keys(byDay[dayTs]).map(sid => ({
					serviceId: sid,
					slots: Object.values(byDay[dayTs][sid]).sort((a, b) => a.slotStart - b.slotStart)
				})).sort((a, b) => (a.slots[0] ? a.slots[0].slotStart : 0) - (b.slots[0] ? b.slots[0].slotStart : 0))
			}))
	}

	_renderSlotCard = (slot, color) => {
		const { benefitId, serviceId, slotStart, slotEnd, resas } = slot
		const benefitTitle = this._getBenefitTitle(benefitId)
		const serviceTitle = this._getServiceTitle(serviceId)
		const benefit = this._getBenefit(benefitId)
		const simultaneous = benefit ? benefit.simultaneous : 0
		const activeResas = resas.filter(r => !r.cancelled)
		const resaCount = activeResas.length
		const count = activeResas.reduce((acc, r) => acc + 1 + (r.participants ? r.participants.length : 0), 0)
		const hasCapacity = simultaneous && simultaneous > 0
		const pct = hasCapacity ? Math.min(Math.round(count / simultaneous * 100), 100) : 0
		const barColor = pct >= 80 ? '#ef4444' : '#6366f1'

		return (
			<div
				key={benefitId + '_' + slotStart}
				className="relative w-full bg-white rounded-3xl flex items-center px-5 py-7 border border-gray-100 shadow-sm cursor-pointer hover:shadow-md hover:border-gray-200 transition-all overflow-hidden"
				onClick={() => this.openSlotDetail(slot)}
			>
				{/* Barre colorée gauche */}
				<div
					className="absolute left-0 rounded-r-full"
					style={{ width: 4, height: 40, top: '50%', transform: 'translateY(-50%)', backgroundColor: color }}
				/>

				{/* Horaire */}
				<div className="shrink-0 pr-6 ml-1" style={{ minWidth: 112 }}>
					<p className="text-xl font-black text-gray-900 leading-none tracking-tight">{this._formatTime(slotStart)}</p>
					<p className="text-xs font-bold text-gray-400 mt-1 uppercase tracking-widest">{this._formatTime(slotEnd)}</p>
				</div>

				{/* Titre + sous-titre */}
				<div className="flex-1 min-w-0">
					<p className="text-base font-black text-gray-900 truncate tracking-tight">{benefitTitle || serviceTitle}</p>
					{benefitTitle && <p className="text-xs font-bold text-gray-400 mt-0.5 truncate italic">{serviceTitle}</p>}
				</div>

				{/* Capacité + réservations */}
				<div className="shrink-0 pl-6 flex flex-col items-end" style={{ minWidth: 180 }}>
					<div className="flex items-center gap-4">
						{/* Ticket count */}
						<span className="flex items-center gap-1 text-xs font-bold text-gray-400">
							<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M13 5v2"/><path d="M13 17v2"/><path d="M13 11v2"/></svg>
							{resaCount}
						</span>
						{/* Participants */}
						{hasCapacity ? (
							<div className="flex items-center gap-1">
								<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
								<span className="text-lg font-black" style={{ color: '#6366f1' }}>{count}</span>
								<span className="text-gray-300 font-bold text-sm">/</span>
								<span className="text-gray-400 font-bold text-sm">{simultaneous}</span>
							</div>
						) : (
							<div className="flex items-center gap-1">
								<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
								<span className="text-sm font-semibold text-gray-600">{count}</span>
							</div>
						)}
					</div>
					{hasCapacity && (
						<div className="flex items-center gap-3 mt-2" style={{ width: 110 }}>
							<div className="flex-1 h-1.5 bg-gray-100 rounded-full overflow-hidden">
								<div className="h-full rounded-full transition-all" style={{ width: pct + '%', backgroundColor: barColor }} />
							</div>
							<span className="text-gray-400 font-black" style={{ fontSize: 10 }}>{pct}%</span>
						</div>
					)}
				</div>
			</div>
		)
	}

	_renderScheduleView = () => {
		const days = this._buildSchedule()
		const { scheduleTab } = this.state

		const SERVICE_COLORS = ['#6366f1', '#f97316', '#10b981', '#f59e0b', '#3b82f6', '#ec4899', '#8b5cf6', '#14b8a6']
		const colorMap = {}
		days.forEach(({ services }) => {
			services.forEach(({ serviceId }) => {
				if (!(serviceId in colorMap))
					colorMap[serviceId] = SERVICE_COLORS[Object.keys(colorMap).length % SERVICE_COLORS.length]
			})
		})

		return (
			<div className="space-y-10 px-6">
				{days.length === 0 ? (
					<div className="flex flex-col items-center justify-center py-16 text-gray-400">
						<span className="text-4xl mb-3" role="img" aria-label="Calendrier">📅</span>
						<p className="text-base">
							{scheduleTab === 'upcoming' ? 'Aucune réservation à venir' : 'Aucune réservation passée'}
						</p>
					</div>
				) : (
					days.map(({ dayTs, services }) => (
						<div key={dayTs}>
							{/* En-tête jour */}
							<div className="flex items-center gap-6 mb-3">
								<h3
									className="text-xs font-black text-gray-400 uppercase shrink-0"
									style={{ letterSpacing: '0.3em' }}
								>
									{this._formatDay(dayTs)}
								</h3>
								<div className="flex-1 h-px bg-gray-200" />
							</div>

							<div className="space-y-6">
								{services.map(({ serviceId, slots }) => {
									const color = colorMap[serviceId]
									return (
										<div key={serviceId} className="space-y-4">
											{/* Tag service */}
											<div className="flex items-center gap-3 pl-1">
												<span
													className="text-xs font-black uppercase tracking-widest px-2 py-0.5 rounded-md"
													style={{ color, backgroundColor: color + '1a' }}
												>
													{this._getServiceTitle(serviceId)}
												</span>
											</div>
											{/* Cartes */}
											<div className="space-y-4">
												{slots.map(slot => this._renderSlotCard(slot, color))}
											</div>
										</div>
									)
								})}
							</div>
						</div>
					))
				)}
			</div>
		)
	}

	// ─── Panneau détail slot ──────────────────────────────────────────────────────

	_renderSlotDetailPanel = () => {
		const slot = this.state.detailSlot
		if (!slot) return null

		const { benefitId, serviceId, slotStart, slotEnd } = slot
		const resas = this.state.reservations.filter(r => {
			const bid = (r.service_benefit && r.service_benefit._id) ? r.service_benefit._id : r.service_benefit
			return bid === benefitId && r.start === slotStart
		})
		const benefit = this._getBenefit(benefitId)
		const benefitTitle = this._getBenefitTitle(benefitId)
		const serviceName = this._getServiceTitle(serviceId)
		const isPast = slotStart * 1000 < Date.now()

		let durationTxt = ''
		if (benefit) {
			const h = benefit.duration_hour || 0
			const m = benefit.duration_minute || 0
			if (h > 0 && m > 0) durationTxt = h + 'h ' + m + 'min'
			else if (h > 0) durationTxt = h + 'h'
			else if (m > 0) durationTxt = m + ' min'
		}

		return (
			<>
				<div className="fixed inset-0 bg-black/30 z-40" onClick={this.closeSlotDetail} />
				<div className="fixed top-0 right-0 w-96 bg-white shadow-2xl z-50" style={{ display: 'flex', flexDirection: 'column', height: '100vh', maxHeight: '100vh' }}>
					{/* Header */}
					<div className="flex items-center justify-between px-5 py-4 border-b border-gray-200">
						<p className="text-base font-semibold text-gray-900">Détails du créneau</p>
						<button onClick={this.closeSlotDetail} className="text-gray-400 hover:text-gray-700 text-xl leading-none">✕</button>
					</div>

					{/* Contenu */}
					<div className="overflow-y-auto px-5 py-5 space-y-5" style={{ flex: '1 1 0', minHeight: 0 }}>
						{/* Service / benefit */}
						<div>
							<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-2">Service</p>
							<div className="border-l-4 border-indigo-500 pl-3">
								<p className="text-base font-semibold text-gray-900">{benefitTitle || serviceName}</p>
								{benefitTitle && <p className="text-base text-gray-400">{serviceName}</p>}
								{durationTxt && <p className="text-base text-gray-500 mt-1">⏱ {durationTxt}</p>}
							</div>
						</div>

						<hr className="border-gray-100" />

						{/* Date & horaire */}
						<div className="flex gap-8">
							<div>
								<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-1">Date</p>
								<p className="text-base text-gray-900">{this._formatDayFull(slotStart)}</p>
							</div>
							<div>
								<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-1">Horaire</p>
								<p className="text-base text-gray-900">{this._formatTime(slotStart)} — {this._formatTime(slotEnd)}</p>
							</div>
						</div>

						<hr className="border-gray-100" />

						{/* Participants */}
						<div>
							<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-2">
								Participants ({resas.filter(r => !r.cancelled).reduce((acc, r) => acc + 1 + (r.participants ? r.participants.length : 0), 0)})
							</p>
							<div className="flex flex-col gap-2">
								{resas.map(r => {
									const isCancelled = !!r.cancelled
									const hasAnswers = !isCancelled && benefit && benefit.questions && benefit.questions.length > 0 && r.answers && r.answers.length > 0
									return (
										<div key={r._id} className={`border rounded-xl overflow-hidden ${isCancelled ? 'border-red-100 opacity-60' : 'border-gray-200'}`}>
											{/* Titulaire */}
											<div className={`flex items-center justify-between px-3 py-2.5 ${isCancelled ? 'bg-red-50' : 'bg-white'}`}>
												<div className="flex-1 min-w-0">
													<div className="flex items-center gap-2 flex-wrap">
														<span className={`w-2 h-2 rounded-full shrink-0 ${isCancelled ? 'bg-red-300' : 'bg-indigo-400'}`} />
														<span className={`text-base font-medium text-gray-800 ${isCancelled ? 'line-through text-gray-400' : ''}`}>{this._getParticipantName(r)}</span>
														{r.client_number && <span className="text-base text-gray-400">#{r.client_number}</span>}
														{isCancelled
															? <span className="text-xs bg-red-100 text-red-500 font-semibold px-1.5 py-0.5 rounded">Annulé {r.cancelled_by === 'client' ? '(client)' : r.cancelled_by === 'staff' ? '(staff)' : ''}</span>
															: <span className="text-xs bg-indigo-50 text-indigo-500 font-semibold px-1.5 py-0.5 rounded">Titulaire</span>
														}
													</div>
													{(r.age || r.phone) && (
														<div className="flex items-center gap-3 ml-4 mt-0.5">
															{r.age && <span className="text-sm text-gray-400">{r.age} ans</span>}
															{r.phone && <span className="text-sm text-gray-400">{r.phone}</span>}
														</div>
													)}
												</div>
												{!isCancelled && (
													<div className="flex items-center gap-1 ml-2 shrink-0">
														<button
															className={`text-base leading-none transition-colors ${isPast ? 'text-gray-200 cursor-not-allowed' : 'text-gray-300 hover:text-indigo-500'}`}
															onClick={isPast ? undefined : (e) => { e.stopPropagation(); this.openEditModal(r, 'holder') }}
															title={isPast ? 'Créneau passé' : 'Modifier'}
															disabled={isPast}
														><span role="img" aria-label="Modifier">✏️</span></button>
														<button
															className={`text-base leading-none transition-colors ${isPast ? 'text-gray-200 cursor-not-allowed' : 'text-gray-300 hover:text-orange-500'}`}
															onClick={isPast ? undefined : (e) => this.askDelete(r._id, e)}
															title={isPast ? 'Créneau passé' : 'Annuler la réservation'}
															disabled={isPast}
														>🗑</button>
													</div>
												)}
											</div>
											{/* Accompagnants */}
											{r.participants && r.participants.map((p, i) => (
												<div key={i} className="flex items-center gap-2 px-3 py-2 bg-gray-50 border-t border-gray-100">
													<div className="flex-1 min-w-0">
														<div className="flex items-center gap-2 flex-wrap">
															<span className="w-2 h-2 rounded-full bg-gray-300 shrink-0" />
															<span className="text-base text-gray-600">{p.identity || ((p.firstname || '') + ' ' + (p.lastname || '')).trim() || '—'}</span>
															<span className="text-xs bg-gray-100 text-gray-400 font-semibold px-1.5 py-0.5 rounded">Accompagnant</span>
														</div>
														{(p.age || p.phone) && (
															<div className="flex items-center gap-3 ml-4 mt-0.5">
																{p.age && <span className="text-sm text-gray-400">{p.age} ans</span>}
																{p.phone && <span className="text-sm text-gray-400">{p.phone}</span>}
															</div>
														)}
													</div>
													{!isPast && (
														<div className="flex items-center gap-1 ml-2 shrink-0">
															<button
																className="text-base leading-none text-gray-300 hover:text-indigo-500 transition-colors"
																onClick={(e) => { e.stopPropagation(); this.openEditModal(r, 'companion', i) }}
																title="Modifier"
															><span role="img" aria-label="Modifier">✏️</span></button>
															<button
																className="text-base leading-none text-gray-300 hover:text-orange-500 transition-colors"
																onClick={(e) => { e.stopPropagation(); this.deleteCompanion(r, i) }}
																title="Supprimer"
															>🗑</button>
														</div>
													)}
												</div>
											))}
											{/* Réponses aux questions */}
											{hasAnswers && (
												<div className="px-3 py-2 bg-gray-50 border-t border-gray-100">
													{benefit.questions.map((q, idx) => {
														const qTitle = q.translations ? (q.translations.find(t => t.lang === this.props.lang_default) || q.translations[0] || {}).title : ''
														return r.answers[idx] ? (
															<div key={idx} className="flex gap-2 text-base mb-0.5">
																<span className="text-gray-400 shrink-0">{qTitle} :</span>
																<span className="text-gray-800">{r.answers[idx]}</span>
															</div>
														) : null
													})}
												</div>
											)}
										</div>
									)
								})}
							</div>
						</div>
					</div>
				</div>
			</>
		)
	}

	// ─── Panneau détail ──────────────────────────────────────────────────────────

	_renderDetailPanel = () => {
		const r = this.state.detailReservation
		if (!r) return null

		const benefitTitle = this._getBenefitTitle(r.service_benefit)
		const serviceName = this._getServiceTitle(r.service)
		const workerName = this._getWorkerName(r.service_worker)
		const name = this._getParticipantName(r)
		const startTxt = this._formatTime(r.start)
		const endTxt = this._formatTime(r.end)
		const dateTxt = this._formatDayFull(r.start)

		// Réponses aux questions
		let questionsJSX = null
		const benefit = (() => {
			const bid = (r.service_benefit && r.service_benefit._id) ? r.service_benefit._id : r.service_benefit
			const benefits = this.state.service_benefits || []
			for (let i = 0; i < benefits.length; i++)
				if (benefits[i]._id === bid) return benefits[i]
			return null
		})()

		if (benefit && benefit.questions && benefit.questions.length > 0 && r.answers && r.answers.length > 0) {
			questionsJSX = (
				<div>
					<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-2">Réponses</p>
					{benefit.questions.map((q, idx) => {
						const qTitle = q.translations ? (q.translations.find(t => t.lang === this.props.lang_default) || q.translations[0] || {}).title : ''
						return r.answers[idx] ? (
							<div key={idx} className="flex gap-2 text-base mb-0.5">
								<span className="text-gray-400 shrink-0">{qTitle}&nbsp;:</span>
								<span className="text-gray-900">{r.answers[idx]}</span>
							</div>
						) : null
					})}
				</div>
			)
		}

		return (
			<>
				{/* Overlay */}
				<div className="fixed inset-0 bg-black/30 z-40" onClick={this.closeDetail} />
				{/* Panel */}
				<div className="fixed top-0 right-0 w-96 bg-white shadow-2xl z-50" style={{ display: 'flex', flexDirection: 'column', height: '100vh', maxHeight: '100vh' }}>
					{/* Header */}
					<div className="flex items-center justify-between px-5 py-4 border-b border-gray-200">
						<div>
							<p className="text-base font-semibold text-gray-900">{serviceName}</p>
							{benefitTitle && <p className="text-base text-gray-400">{benefitTitle}</p>}
							{r.cancelled && <span className="inline-block mt-1 text-xs bg-gray-100 text-gray-500 font-semibold px-2 py-0.5 rounded">Réservation annulée</span>}
						</div>
						<button onClick={this.closeDetail} className="text-gray-400 hover:text-gray-700 text-xl leading-none">✕</button>
					</div>

					{/* Contenu */}
					<div className="overflow-y-auto px-5 pt-5 space-y-5" style={{ flex: '1 1 0', minHeight: 0, paddingBottom: '80px' }}>
						{/* Date & heure */}
						<div>
							<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-2">Créneau</p>
							<p className="text-base text-gray-900">{dateTxt}</p>
							<p className="text-base text-gray-900">{startTxt} → {endTxt}</p>
							{workerName && <p className="text-base text-gray-400 mt-1">Par {workerName}</p>}
						</div>

						<hr className="border-gray-100" />

						{/* Participant */}
						<div>
							<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-2">Participant</p>
							<p className="text-base font-medium text-gray-900">{name}</p>
							{r.client_number && <p className="text-base text-gray-400">Client #{r.client_number}</p>}
							{r.age > 0 && <p className="text-base text-gray-500">{r.age} ans</p>}
							{r.phone && <p className="text-base text-gray-500">Tél : {r.phone}</p>}
						</div>

						{/* Accompagnants */}
						{r.participants && r.participants.length > 0 && (
							<div>
								<p className="text-base font-semibold text-gray-400 uppercase tracking-wider mb-2">Accompagnants</p>
								{r.participants.map((p, i) => (
									<div key={i} className="mb-2">
										<p className="text-base font-medium text-gray-900">{p.identity || ((p.firstname || '') + ' ' + (p.lastname || '')).trim() || '—'}</p>
										{p.age > 0 && <p className="text-base text-gray-500">{p.age} ans</p>}
										{p.phone && <p className="text-base text-gray-500">Tél : {p.phone}</p>}
									</div>
								))}
							</div>
						)}

						{questionsJSX && <hr className="border-gray-100" />}
						{questionsJSX}

						<hr className="border-gray-100" />

						{/* Source */}
						<div className="flex items-center gap-2">
							<p className="text-base text-gray-400">Réservé depuis</p>
							{this._renderSourceBadge(r.from)}
						</div>
					</div>

					{/* Footer */}
					<div style={{ position: 'fixed', bottom: 0, right: 0, width: '24rem', padding: '16px 20px', borderTop: '1px solid #e5e7eb', backgroundColor: '#ffffff', zIndex: 51 }}>
						<button
							className="w-full text-base font-medium rounded-xl py-2.5 transition-colors flex items-center justify-center gap-2 mb-2"
							style={{ backgroundColor: '#f8fafc', color: '#374151', border: '1px solid #e5e7eb' }}
							onClick={() => this._printTicket(r)}
						>
							<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
							</svg>
							Imprimer ticket
						</button>
						{!r.cancelled && (
							<button
								className="w-full text-white text-base font-medium rounded-xl py-2.5 transition-colors"
								style={{ backgroundColor: '#f97316', border: 'none' }}
								onClick={(e) => this.askDelete(r._id, e)}
							>
								Annuler la réservation
							</button>
						)}
					</div>
				</div>
			</>
		)
	}

	// ─── Modal ajout ─────────────────────────────────────────────────────────────

	_renderAddModal = () => {
		if (!this.state.addModal) return null
		const { addStep, addBenefit, addDay, addSlot, addForm, addError, addSuccess, addUsers, addWeekOffset } = this.state
		const services = this.state.services || []
		const serviceIds = new Set(services.map(s => s._id))
		const allBenefits = (this.state.service_benefits || []).filter(b =>
			serviceIds.has(b.service) && b.open_hours && b.open_hours.length > 0
		)
		const filterService = this.state.filterService
		const benefits = filterService !== 'all' ? allBenefits.filter(b => b.service === filterService) : allBenefits
		const inputClass = "w-full border border-gray-300 rounded-xl px-3 py-2.5 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500"
		const labelClass = "block text-base font-medium text-gray-700 mb-1"
		const STEPS = ['Prestation', 'Créneau', 'Participant']
		const DAY_SHORT = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']

		const getBenefitTitle = (b) => {
			for (const t of (b.translations || []))
				if (t.lang === this.props.lang_default) return t.subtitle || t.title || ''
			return ''
		}

		return (
			<>
				<div className="fixed inset-0 bg-black/40 z-40" onClick={this.closeAddModal} />
				<div className="fixed inset-0 flex items-end sm:items-center justify-center z-50 sm:p-4">
					<div className="bg-white rounded-t-3xl sm:rounded-2xl shadow-2xl w-full sm:max-w-lg flex flex-col" style={{ height: '85vh' }}>

						{/* Header */}
						<div className="flex items-center justify-between px-5 pt-5 pb-2 shrink-0">
							<div className="flex items-center gap-2">
								{addStep > 1 && (
									<button onClick={() => this.setState({ addStep: addStep - 1, addError: null })} className="text-gray-400 hover:text-gray-700 text-xl leading-none mr-1">←</button>
								)}
								<h2 className="text-base font-semibold text-gray-900">{STEPS[addStep - 1]}</h2>
							</div>
							<button onClick={this.closeAddModal} className="text-gray-400 hover:text-gray-700 text-xl leading-none">✕</button>
						</div>

						{/* Barre de progression */}
						<div className="flex gap-1.5 px-5 pb-4 shrink-0">
							{STEPS.map((_, i) => (
								<div key={i} className={`h-1 rounded-full flex-1 transition-all ${i < addStep ? 'bg-indigo-600' : 'bg-gray-200'}`} />
							))}
						</div>

						{/* Contenu */}
						<div className="flex-1 overflow-y-auto">

							{/* ── Étape 1 : Prestation ── */}
							{addStep === 1 && (
								<div className="px-5 pb-6 space-y-2">
									<p className="text-base text-gray-400 pb-2">Sélectionnez une prestation pour continuer.</p>
									{benefits.length === 0
										? <p className="text-base text-gray-400 text-center py-8">Aucune prestation configurée.</p>
										: benefits.map(b => {
											const title = getBenefitTitle(b)
											let serviceTitle = ''
											for (const s of services)
												if (s._id === b.service) { for (const t of s.translations) if (t.lang === this.props.lang_default) { serviceTitle = t.title; break }; break }
											const h = b.duration_hour, m = b.duration_minute
											const durationTxt = h > 0 && m > 0 ? h + 'h' + String(m).padStart(2, '0') : h > 0 ? h + 'h' : m + ' min'
											return (
												<button key={b._id} type="button" onClick={() => this.selectAddBenefit(b)}
													className="w-full text-left border border-gray-200 rounded-2xl px-4 py-3.5 hover:border-indigo-400 hover:bg-indigo-50 active:bg-indigo-100 transition-all">
													<div className="flex items-center justify-between gap-3">
														<div className="min-w-0">
															<p className="text-base font-semibold text-gray-900 truncate">{title}</p>
															{serviceTitle && <p className="text-base text-gray-400 mt-0.5">{serviceTitle}</p>}
														</div>
														<div className="text-right shrink-0">
															<p className="text-base text-gray-500">{durationTxt}</p>
															{b.simultaneous ? <p className="text-base text-gray-400">{b.simultaneous} pl. max</p> : null}
														</div>
													</div>
												</button>
											)
										})
									}
								</div>
							)}

							{/* ── Étape 2 : Créneau ── */}
							{addStep === 2 && addBenefit && (() => {
								const weekDays = this._getAddWeekDays()
								const todayMidnight = (() => { const d = new Date(); d.setHours(0,0,0,0); return Math.round(d.getTime() / 1000) })()
								const slots = addDay ? this._generateSlots(addBenefit, addDay) : []
								const capacity = addBenefit.simultaneous || null
								const fmtWeekRange = () => {
									const fmt = (ts) => { const d = new Date(ts * 1000); return d.getDate() + ' ' + ['jan','fév','mar','avr','mai','jun','jul','aoû','sep','oct','nov','déc'][d.getMonth()] }
									return fmt(weekDays[0]) + ' – ' + fmt(weekDays[6])
								}
								return (
									<div className="px-5 pb-6">
										{/* Résumé prestation */}
										<div className="mb-4 px-3 py-2 bg-indigo-50 rounded-xl text-base font-medium text-indigo-700">{getBenefitTitle(addBenefit)}</div>
										<p className="text-base text-gray-400 pb-1">Sélectionnez un créneau pour continuer.</p>

										{/* Navigation semaine */}
										<div className="flex items-center justify-between mb-3">
											<button onClick={() => { const d = new Date(weekDays[0] * 1000); d.setDate(d.getDate() - 7); d.setHours(0,0,0,0); this.setState({ addWeekOffset: addWeekOffset - 1, addDay: Math.round(d.getTime() / 1000), addSlot: null }) }} className="p-2 text-gray-400 hover:text-gray-700 text-lg leading-none">‹</button>
											<span className="text-base font-medium text-gray-600">{fmtWeekRange()}</span>
											<button onClick={() => { const d = new Date(weekDays[0] * 1000); d.setDate(d.getDate() + 7); d.setHours(0,0,0,0); this.setState({ addWeekOffset: addWeekOffset + 1, addDay: Math.round(d.getTime() / 1000), addSlot: null }) }} className="p-2 text-gray-400 hover:text-gray-700 text-lg leading-none">›</button>
										</div>

										{/* Strip des jours */}
										<div className="flex gap-1.5 mb-5">
											{weekDays.map(dayTs => {
												const d = new Date(dayTs * 1000)
												const isToday = dayTs === todayMidnight
												const isSelected = dayTs === addDay
												const hasSlots = this._generateSlots(addBenefit, dayTs).length > 0
												return (
													<button key={dayTs} type="button" onClick={() => this.selectAddDay(dayTs)}
														className={`flex-1 flex flex-col items-center py-2 pb-1.5 rounded-xl border transition-all ${isSelected ? 'bg-indigo-600 text-white border-indigo-600' : isToday ? 'bg-indigo-50 text-indigo-700 border-indigo-200' : 'text-gray-600 hover:bg-gray-100 border-gray-200'}`}>
														<span className="text-xs font-medium">{DAY_SHORT[d.getDay()]}</span>
														<span className="text-sm font-bold mt-0.5">{d.getDate()}</span>
														<span className="mt-1 h-1.5 w-1.5 rounded-full" style={{ backgroundColor: hasSlots ? (isSelected ? 'rgba(255,255,255,0.8)' : '#6366f1') : 'transparent' }} />
													</button>
												)
											})}
										</div>

										{/* Créneaux */}
										{!addDay
											? <p className="text-base text-gray-400 text-center py-6">Sélectionnez un jour.</p>
											: slots.length === 0
												? (() => {
													const nextDay = this._findNextAvailableDay(addBenefit, addDay)
													const fmtNext = nextDay ? (() => {
														const d = new Date(nextDay * 1000)
														const months = ['jan.','fév.','mars','avr.','mai','juin','juil.','août','sep.','oct.','nov.','déc.']
														return d.getDate() + ' ' + months[d.getMonth()]
													})() : null
													return (
														<div className="text-center py-6">
															<p className="text-base text-gray-400 mb-3">Aucun créneau disponible ce jour.</p>
															{nextDay && (
																<button type="button" onClick={() => this.goToNextAvailableDay(nextDay)}
																	className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-indigo-50 text-indigo-700 text-base font-medium hover:bg-indigo-100 transition-colors">
																	Prochain créneau : {fmtNext} →
																</button>
															)}
														</div>
													)
												})()
												: <div className="space-y-2">
													{slots.map((slot, i) => {
														const isPast = (addDay + slot.start * 60) < Math.floor(Date.now() / 1000)
														const isFull = capacity && slot.booked >= capacity
														const pct = capacity ? Math.min(Math.round(slot.booked / capacity * 100), 100) : 0
														const barColor = isFull ? '#ef4444' : pct >= 70 ? '#fbbf24' : '#4ade80'
														return (
															<button key={i} type="button" onClick={() => this.selectAddSlot(slot)}
																disabled={isFull}
																className={`w-full flex items-center gap-3 px-4 py-3 border rounded-xl text-left transition-all ${isFull ? 'border-gray-200 bg-gray-50 opacity-50 cursor-not-allowed' : isPast ? 'border-gray-200 opacity-60 hover:border-indigo-300' : 'border-gray-200 hover:border-indigo-400 hover:bg-indigo-50'}`}>
																<span className="text-base font-semibold text-gray-800 shrink-0 w-20">
																	{this._formatTime(addDay + slot.start * 60)}
																</span>
																<span className="text-base text-gray-400 shrink-0">→ {this._formatTime(addDay + slot.end * 60)}</span>
																<div className="ml-auto flex items-center gap-2 shrink-0">
																	{capacity
																		? <>
																			<span className="text-base font-medium text-gray-700">{slot.booked}/{capacity}</span>
																			<div className="w-10 h-1.5 bg-gray-100 rounded-full overflow-hidden">
																				<div className="h-1.5 rounded-full" style={{ width: pct + '%', backgroundColor: barColor }} />
																			</div>
																		</>
																		: <span className="text-base text-gray-400">{slot.booked} inscrit{slot.booked > 1 ? 's' : ''}</span>
																	}
																</div>
																{isPast && <span className="text-xs text-gray-400 bg-gray-100 px-1.5 py-0.5 rounded">Passé</span>}
															</button>
														)
													})}
												</div>
										}
									</div>
								)
							})()}

							{/* ── Étape 3 : Participant ── */}
							{addStep === 3 && addBenefit && addSlot && (
								<div className="px-5 pb-6">
									{/* Résumé créneau */}
									<div className="mb-4 px-3 py-2.5 bg-indigo-50 rounded-xl text-base text-indigo-700">
										<span className="font-medium">{getBenefitTitle(addBenefit)}</span>
										<span className="text-indigo-400 mx-2">·</span>
										<span>{this._formatDayFull(addDay)} · {this._formatTime(addDay + addSlot.start * 60)} → {this._formatTime(addDay + addSlot.end * 60)}</span>
									</div>
									<p className="text-base text-gray-400 pb-1 mt-1">Renseignez les informations du participant.</p>

									{addSuccess && <div className="mb-3 p-3 bg-green-50 border border-green-200 rounded-xl text-base text-green-700">{addSuccess}</div>}
									{addError && <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-xl text-base text-red-700">{addError}</div>}

									<form onSubmit={this.submitAdd} className="space-y-3">
										<div>
											<label className={labelClass}>Numéro client <span className="text-gray-400 font-normal">(optionnel)</span></label>
											<input className={inputClass} value={addForm.client_number} onChange={e => { this.handleAddField('client_number', e); this.lookupClient(e.target.value) }} placeholder="ex: 42" />
										</div>
										{addUsers.length > 0 && (
											<div>
												<label className={labelClass}>Compte webapp</label>
												<select className={inputClass + ' bg-white'} value={addForm.user} onChange={this.handleUserSelect}>
													<option value="">-- Aucun --</option>
													{addUsers.map(u => <option key={u._id} value={u._id}>{u.firstname} {u.lastname}</option>)}
												</select>
											</div>
										)}
										<div>
											<label className={labelClass}>Nom et prénom</label>
											<input className={inputClass} value={addForm.identity} onChange={e => this.handleAddField('identity', e)} placeholder="ex: Mme. Dupont Marie" />
										</div>
										{addBenefit.age && (
											<div>
												<label className={labelClass}>Âge *</label>
												<input className={inputClass} value={addForm.age} onChange={e => this.handleAddField('age', e)} placeholder="ex: 35" />
											</div>
										)}
										<div>
											<label className={labelClass}>Téléphone <span className="text-gray-400 font-normal">(optionnel)</span></label>
											<input className={inputClass} value={addForm.phone} onChange={e => this.handleAddField('phone', e)} placeholder="ex: 06 12 34 56 78" />
										</div>
										<div>
											<label className={labelClass + ' text-gray-400'}>Email <span className="font-normal text-gray-300">(à venir)</span></label>
											<input className={inputClass + ' opacity-40 cursor-not-allowed bg-gray-50'} value={addForm.email} disabled placeholder="ex: dupont@email.com" />
											<p className="text-xs text-gray-300 mt-1">En attente d'intégration en base de données.</p>
										</div>
										{addBenefit.questions && addBenefit.questions.map((q, idx) => {
											let title = ''
											for (const t of (q.translations || []))
												if (t.lang === this.props.lang_default) { title = t.title; break }
											if (q.mandatory) title += ' *'
											return (
												<div key={idx}>
													<label className={labelClass}>{title}</label>
													<input className={inputClass} value={addForm.answers[idx] || ''} onChange={e => this.handleAddAnswer(idx, e)} />
												</div>
											)
										})}
									{/* ── Accompagnants ── */}
									{(() => {
										const hasCapacity = addBenefit.simultaneous > 0
										const remaining = hasCapacity ? addBenefit.simultaneous - addSlot.booked : Infinity
										const slotsForCompanions = remaining - 1
										const canAdd = !hasCapacity || addForm.participants.length < slotsForCompanions
										return (
											<div className="pt-4 border-t border-gray-100">
												<div className="flex items-center justify-between mb-1">
													<p className="text-base font-semibold text-gray-700">Accompagnants</p>
													{canAdd && (
														<button type="button" onClick={this.addParticipant}
															className="text-sm font-medium text-indigo-600 hover:text-indigo-800 transition-colors">
															+ Ajouter
														</button>
													)}
												</div>
												{hasCapacity && slotsForCompanions - addForm.participants.length > 0 && (
													<p className="text-xs text-gray-400 mb-3">{slotsForCompanions - addForm.participants.length} place(s) dispo.</p>
												)}
												{(!hasCapacity || slotsForCompanions - addForm.participants.length <= 0) && <div className="mb-3" />}
												{addForm.participants.map((p, idx) => (
													<div key={idx} className="bg-gray-50 rounded-xl border border-gray-200 p-4 mb-3">
														<div className="flex justify-between items-center mb-3">
															<div className="flex items-center gap-2">
																<p className="text-sm font-semibold text-gray-600">Accompagnant {idx + 1}</p>
																{hasCapacity && idx === slotsForCompanions - 1 && (
																	<span className="text-xs font-medium px-2 py-0.5 rounded-full bg-red-100 text-red-600">Dernière place</span>
																)}
															</div>
															<button type="button" onClick={() => this.removeParticipant(idx)}
																className="text-red-400 hover:text-red-600 text-sm font-medium transition-colors">
																Supprimer
															</button>
														</div>
														<div className="space-y-3">
															<div>
																<label className={labelClass}>Nom et prénom</label>
																<input className={inputClass} value={p.identity} onChange={e => this.handleParticipantField(idx, 'identity', e)} placeholder="ex: M. Martin Paul" />
															</div>
															{addBenefit.age && (
																<div>
																	<label className={labelClass}>Âge *</label>
																	<input className={inputClass} value={p.age} onChange={e => this.handleParticipantField(idx, 'age', e)} placeholder="ex: 35" />
																</div>
															)}
															<div>
																<label className={labelClass}>Téléphone <span className="text-gray-400 font-normal">(optionnel)</span></label>
																<input className={inputClass} value={p.phone} onChange={e => this.handleParticipantField(idx, 'phone', e)} placeholder="ex: 06 12 34 56 78" />
															</div>
															<div>
																<label className={labelClass + ' text-gray-400'}>Email <span className="font-normal text-gray-300">(à venir)</span></label>
																<input className={inputClass + ' opacity-40 cursor-not-allowed bg-gray-50'} disabled placeholder="ex: dupont@email.com" />
															</div>
														</div>
													</div>
												))}
												{!canAdd && (
													<div className="rounded-xl px-4 py-3 flex items-start gap-2 text-sm font-medium" style={{ backgroundColor: '#fff7ed', border: '1px solid #fb923c', color: '#9a3412' }}>
														<span className="shrink-0 mt-0.5" role="img" aria-label="Avertissement">⚠️</span>
														<span>Capacité maximale atteinte — aucune place disponible pour un accompagnant supplémentaire.</span>
													</div>
												)}
											</div>
										)
									})()}

											<div className="pt-2">
												<button type="submit"
													disabled={addBenefit.simultaneous > 0 && addBenefit.simultaneous - addSlot.booked <= 0}
													className="w-full bg-indigo-600 hover:bg-indigo-700 text-white text-base font-medium rounded-xl py-3 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
													Enregistrer
												</button>
											</div>
									</form>
								</div>
							)}
						</div>
					</div>
				</div>
			</>
		)
	}

	// ─── Modal édition participant ────────────────────────────────────────────────

	_renderEditModal = () => {
		const { editModal, editType, editForm, editSaving, editError } = this.state
		if (!editModal) return null
		const isHolder = editType === 'holder'
		return (
			<>
				<div className="fixed inset-0 bg-black/40 z-50" onClick={this.closeEditModal} />
				<div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none">
					<div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm pointer-events-auto">
						<div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
							<p className="text-base font-semibold text-gray-900">{isHolder ? 'Modifier le titulaire' : "Modifier l'accompagnant"}</p>
							<button onClick={this.closeEditModal} className="text-gray-400 hover:text-gray-700 text-xl leading-none">✕</button>
						</div>
						<div className="px-5 py-4 space-y-3">
							<div>
								<label className="block text-sm font-medium text-gray-600 mb-1">Nom / Prénom</label>
								<input
									type="text"
									className="w-full border border-gray-200 rounded-xl px-3 py-2 text-base focus:outline-none focus:border-indigo-400"
									value={editForm.identity || ''}
									onChange={e => this.setState({ editForm: { ...editForm, identity: e.target.value } })}
									placeholder="Nom prénom"
									autoFocus
								/>
							</div>
							<div>
								<label className="block text-sm font-medium text-gray-600 mb-1">Âge</label>
								<input
									type="text"
									className="w-full border border-gray-200 rounded-xl px-3 py-2 text-base focus:outline-none focus:border-indigo-400"
									value={editForm.age || ''}
									onChange={e => this.setState({ editForm: { ...editForm, age: e.target.value } })}
									placeholder="ex: 42"
								/>
							</div>
							<div>
								<label className="block text-sm font-medium text-gray-600 mb-1">Téléphone</label>
								<input
									type="text"
									className="w-full border border-gray-200 rounded-xl px-3 py-2 text-base focus:outline-none focus:border-indigo-400"
									value={editForm.phone || ''}
									onChange={e => this.setState({ editForm: { ...editForm, phone: e.target.value } })}
									placeholder="ex: 06 12 34 56 78"
								/>
							</div>
							{isHolder && (
								<div>
									<label className="block text-sm font-medium text-gray-600 mb-1">Nº client</label>
									<input
										type="text"
										className="w-full border border-gray-200 rounded-xl px-3 py-2 text-base focus:outline-none focus:border-indigo-400"
										value={editForm.client_number || ''}
										onChange={e => this.setState({ editForm: { ...editForm, client_number: e.target.value } })}
										placeholder="ex: 1042"
									/>
								</div>
							)}
							{editError && <p className="text-sm text-red-500">{editError}</p>}
						</div>
						<div className="px-5 pb-5 flex gap-2">
							<button
								type="button"
								className="flex-1 border border-gray-200 text-gray-600 text-base font-medium rounded-xl py-2.5 hover:bg-gray-50 transition-colors"
								onClick={this.closeEditModal}
							>Annuler</button>
							<button
								type="button"
								className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white text-base font-medium rounded-xl py-2.5 transition-colors disabled:opacity-50"
								onClick={this.saveEdit}
								disabled={editSaving}
							>{editSaving ? 'Enregistrement...' : 'Enregistrer'}</button>
						</div>
					</div>
				</div>
			</>
		)
	}

	// ─── Render principal ────────────────────────────────────────────────────────

	_renderTitleRow = () => {
		return (
			<div className="flex items-center justify-between px-6 pb-2">
				<div>
					<h2
						className="text-3xl font-bold text-gray-900"
						style={{ fontFamily: "'Fraunces', Georgia, serif" }}
					>
						Planning &amp; réservations
					</h2>
					<div className="flex items-center gap-2 mt-2 text-gray-500">
						<div role="button" tabIndex={0} onClick={this.prevWeek} onKeyDown={e => e.key === 'Enter' && this.prevWeek()} className="p-1 rounded hover:bg-gray-200 transition-colors cursor-pointer">
							<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
							</svg>
						</div>
						<span className="text-sm font-medium text-gray-700">{this._formatWeekRange()}</span>
						<div role="button" tabIndex={0} onClick={this.nextWeek} onKeyDown={e => e.key === 'Enter' && this.nextWeek()} className="p-1 rounded hover:bg-gray-200 transition-colors cursor-pointer">
							<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
							</svg>
						</div>
						<div role="button" tabIndex={0} onClick={this.goToToday} onKeyDown={e => e.key === 'Enter' && this.goToToday()} className="text-xs font-semibold text-indigo-600 hover:underline ml-1">
							Aujourd'hui
						</div>
					</div>
				</div>
				<div className="flex items-center gap-3">
					<div
						role="button" tabIndex={0}
						onClick={this._downloadCsv}
						onKeyDown={e => e.key === 'Enter' && this._downloadCsv()}
						className="flex items-center gap-2 bg-white border border-gray-200 px-4 py-2 rounded-xl text-sm font-semibold shadow-sm hover:bg-gray-50 transition-colors cursor-pointer select-none"
					>
						<svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
						</svg>
						Exporter CSV
					</div>
					<div
						role="button" tabIndex={0}
						onClick={this.openAddModal}
						onKeyDown={e => e.key === 'Enter' && this.openAddModal()}
						className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-xl text-sm font-semibold transition-colors cursor-pointer select-none"
					>
						<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
						</svg>
						Nouvelle réservation
					</div>
				</div>
			</div>
		)
	}

	_renderTabRow = () => {
		const { view, scheduleTab } = this.state
		return (
			<div className="flex items-center justify-between px-6 border-b border-gray-200">
				<div className="flex items-center gap-8">
					<div
						role="button" tabIndex={0}
						onClick={() => this.setState({ scheduleTab: 'upcoming', view: 'schedule' })}
						onKeyDown={e => e.key === 'Enter' && this.setState({ scheduleTab: 'upcoming', view: 'schedule' })}
						className={`pb-3 text-xs font-black uppercase tracking-widest transition-colors relative cursor-pointer select-none ${scheduleTab === 'upcoming' && view === 'schedule' ? 'text-indigo-600' : 'text-gray-400 hover:text-gray-600'}`}
					>
						À venir
						{scheduleTab === 'upcoming' && view === 'schedule' && (
							<span className="absolute bottom-0 left-0 right-0 h-0.5 bg-indigo-600 rounded-full" />
						)}
					</div>
					<div
						role="button" tabIndex={0}
						onClick={() => this.setState({ scheduleTab: 'past', view: 'schedule' })}
						onKeyDown={e => e.key === 'Enter' && this.setState({ scheduleTab: 'past', view: 'schedule' })}
						className={`pb-3 text-xs font-black uppercase tracking-widest transition-colors relative cursor-pointer select-none ${scheduleTab === 'past' && view === 'schedule' ? 'text-indigo-600' : 'text-gray-400 hover:text-gray-600'}`}
					>
						Passées
						{scheduleTab === 'past' && view === 'schedule' && (
							<span className="absolute bottom-0 left-0 right-0 h-0.5 bg-indigo-600 rounded-full" />
						)}
					</div>
				</div>
				<div className="flex items-center gap-1 p-1 bg-gray-100 rounded-xl mb-2">
					<div
						role="button" tabIndex={0}
						onClick={() => this.setState({ view: 'schedule' })}
						onKeyDown={e => e.key === 'Enter' && this.setState({ view: 'schedule' })}
						className={`px-4 py-1.5 rounded-lg text-xs font-black uppercase tracking-wider transition-all cursor-pointer select-none ${view === 'schedule' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
					>
						Planning
					</div>
					<div
						role="button" tabIndex={0}
						onClick={() => this.setState({ view: 'week' })}
						onKeyDown={e => e.key === 'Enter' && this.setState({ view: 'week' })}
						className={`px-4 py-1.5 rounded-lg text-xs font-black uppercase tracking-wider transition-all cursor-pointer select-none ${view === 'week' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}
					>
						Semaine
					</div>
				</div>
			</div>
		)
	}

	_renderStatsCards = () => {
		const { allReservations, view } = this.state
		const now = Math.round(Date.now() / 1000)
		const activeResas = (allReservations || []).filter(r => !r.cancelled)
		const upcomingCount = activeResas.filter(r => r.start > now).length
		const totalCount = activeResas.length

		// Par service : aujourd'hui en vue planning, semaine courante en vue semaine
		let statsResas = activeResas
		if (view === 'schedule') {
			const d = new Date()
			d.setHours(0, 0, 0, 0)
			const todayStart = Math.round(d.getTime() / 1000)
			const todayEnd = todayStart + 86400
			statsResas = activeResas.filter(r => r.start >= todayStart && r.start < todayEnd)
		}

		const byService = {}
		for (const r of statsResas) {
			const sid = r.service && r.service._id ? String(r.service._id) : String(r.service)
			const sname = this._getServiceTitle(sid)
			const pax = 1 + (r.participants ? r.participants.length : 0)
			if (!byService[sid])
				byService[sid] = { name: sname, resaCount: 0, paxCount: 0 }
			byService[sid].resaCount++
			byService[sid].paxCount += pax
		}
		const serviceStats = Object.values(byService).sort((a, b) => b.paxCount - a.paxCount).slice(0, 5)

		return (
			<div className="grid grid-cols-3 gap-6 px-6">
				<div className="bg-white rounded-3xl border border-gray-200 shadow-sm p-6">
					<p className="text-xs font-black text-gray-400 uppercase tracking-widest mb-5">
						Pax par type d'activité
						<span className="ml-2 font-normal normal-case tracking-normal text-gray-300">
							{view === 'schedule' ? "— aujourd'hui" : `— ${this._formatWeekRange()}`}
						</span>
					</p>
					{serviceStats.length === 0 ? (
						<p className="text-sm text-gray-300">Aucune réservation.</p>
					) : (
						<div className="flex flex-col gap-4 overflow-y-auto" style={{ maxHeight: '12rem' }}>
							{serviceStats.map((s, i) => (
								<div key={i} className="flex items-center justify-between">
									<div className="min-w-0">
										<p className="text-sm font-black text-gray-800 truncate">{s.name}</p>
										<p className="text-xs font-bold text-gray-400 uppercase tracking-wide mt-0.5">{s.resaCount} résas.</p>
									</div>
									<div className="flex items-baseline gap-1 shrink-0 ml-4">
										<span className="text-2xl font-black" style={{ color: '#6366f1' }}>{s.paxCount}</span>
										<span className="text-xs font-black text-gray-400 uppercase tracking-widest">Pax</span>
									</div>
								</div>
							))}
						</div>
					)}
				</div>
				<div className="bg-white rounded-3xl border border-gray-200 shadow-sm p-6">
					<p className="text-xs font-semibold text-gray-500 uppercase tracking-tight mb-4">Total réservations</p>
					<span className="text-5xl font-black text-gray-900">{totalCount}</span>
					<p className="text-sm text-gray-400 mt-1 italic">Total cette période</p>
				</div>
				<div className="bg-white rounded-3xl border border-gray-200 shadow-sm p-6">
					<p className="text-xs font-semibold text-gray-500 uppercase tracking-tight mb-4">À venir</p>
					<span className="text-5xl font-black" style={{ color: '#f97316' }}>{upcomingCount}</span>
					<p className="text-sm text-gray-400 mt-1 italic">Slots restants</p>
					{upcomingCount > 0 && (
						<div className="mt-4 flex items-center gap-2 text-emerald-600">
							<span className="w-1.5 h-1.5 bg-emerald-500 rounded-full" style={{ display: 'inline-block' }} />
							<span className="text-xs font-black uppercase tracking-widest">En direct</span>
						</div>
					)}
				</div>
			</div>
		)
	}


	render() {
		const { services, service_workers, clients, webapp_users } = this.state
		const permissions = this.props.user.permissions
		if (!permissions || !permissions.services || permissions.services === 0)
			return (<Redirect to="/" />)

		if (services === null || service_workers === null || clients === null || webapp_users === null) {
			return (
				<div className="flex items-center justify-center h-64">
					<Loader />
				</div>
			)
		}

		if (this.props.features !== 'premium') {
			return (
				<>
					<OnlyPremiumEmpty
						title="Planning"
						subtitle="Visualisez l'ensemble de vos réservations & inscriptions"
						emptyFolder="Commencez par créer un service"
						emptyFolderSubtitle="Pas de réservations"
						navName="Services"
						navPath="/Services"
					/>
					<div className="mt-10">
						<PremiumAlert
							content="Mettez votre abonnement à niveau avec la formule premium pour accéder aux services !"
							button_text="En savoir plus"
						/>
					</div>
				</>
			)
		}

		const { view, filterService, loading, globalError, globalSuccess, allReservations } = this.state
		const allServices = this.state.services || []

		return (
		<div>
				{/* Modaux */}
				<Modal
					dismissible={false}
					content="Annuler cette réservation ? Elle restera visible dans les vues mais sera marquée comme annulée."
					open_modal={this.state.deleteModal}
					answerModal={this.answerModal}
				/>
				{this._renderAddModal()}
				{this._renderEditModal()}
				{this._renderDetailPanel()}
				{this._renderSlotDetailPanel()}

				{/* Top bar */}
				<ServiceSubPageHeader
					onBack={() => this.props.history.push('/services')}
					user={this.props.user}
				/>

				{/* Contenu */}
				<div className="space-y-6 py-6">
					{globalError && (
						<div className="mx-6 p-3 bg-red-50 border border-red-200 rounded-xl text-sm text-red-700">{globalError}</div>
					)}
					{globalSuccess && (
						<div className="mx-6 p-3 bg-green-50 border border-green-200 rounded-xl text-sm text-green-700">{globalSuccess}</div>
					)}

					{this._renderTitleRow()}
					{this._renderTabRow()}
					{this._renderStatsCards()}

						{/* Chips filtre service */}
						{allServices.length > 1 && (() => {
							const MAX_VISIBLE = 8
							const { filterExpanded } = this.state
							const bookingServices = allServices.filter(s => s.type !== 'vente')
							const hidden = bookingServices.length > MAX_VISIBLE
							const visible = (hidden && !filterExpanded) ? bookingServices.slice(0, MAX_VISIBLE) : bookingServices
							const extraCount = bookingServices.length - MAX_VISIBLE
							const countByService = {}
							let totalCount = 0
							for (let i = 0; i < allReservations.length; i++) {
								const r = allReservations[i]
								if (r.cancelled) continue
								const sid = (r.service && r.service._id) ? r.service._id : r.service
								countByService[sid] = (countByService[sid] || 0) + 1
								totalCount++
							}
							return (
								<div className="flex items-start gap-2 px-5 py-3 border-b border-gray-100">
									<div className="flex flex-wrap gap-2 flex-1">
										<FilterChip
											label="Tous"
											count={totalCount}
											active={filterService === 'all'}
											onClick={() => this._applyServiceFilter('all')}
										/>
										{visible.map(s => {
											let title = s.name
											for (let i = 0; i < s.translations.length; i++)
												if (s.translations[i].lang === this.props.lang_default) { title = s.translations[i].title; break }
											const cnt = countByService[s._id] || 0
											const active = filterService === s._id
											return (
												<FilterChip
													key={s._id}
													label={title}
													count={cnt}
													active={active}
													onClick={() => this._applyServiceFilter(s._id)}
												/>
											)
										})}
									</div>
									{hidden && (
										<button
											className="shrink-0 px-4 py-1.5 text-sm font-medium rounded-full border border-gray-200 text-gray-500 hover:bg-gray-50 transition-colors"
											onClick={() => this.setState({ filterExpanded: !filterExpanded })}
										>{filterExpanded ? 'Voir moins ▲' : `+ ${extraCount} autres ▾`}</button>
									)}
								</div>
							)
						})()}

										{/* Corps : loader ou vue */}
					<div>
						{loading ? (
							<div className="flex items-center justify-center py-12">
								<Loader />
							</div>
						) : (
							view === 'week' ? this._renderWeekView() : this._renderScheduleView()
						)}
					</div>
				</div>
		</div>
		)
	}
}

export default Bookings
